import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetAllTimelinePermohonan = createAsyncThunk(
  "Timeline/GetAllTimelinePermohonan",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}permohonan/timeline/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllTimelinePraktikum = createAsyncThunk(
  "Timeline/GetAllTimelinePraktikum",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}praktikum/timeline/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const TimelineSlice = createSlice({
  name: "Timeline",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // PERMOHONAN
    builder.addCase(GetAllTimelinePermohonan.pending, loadingHandler);
    builder.addCase(GetAllTimelinePermohonan.fulfilled, fulfilledHandler);
    builder.addCase(GetAllTimelinePermohonan.rejected, rejectedHandler);
    // PRAKTIKUM
    builder.addCase(GetAllTimelinePraktikum.pending, loadingHandler);
    builder.addCase(GetAllTimelinePraktikum.fulfilled, fulfilledHandler);
    builder.addCase(GetAllTimelinePraktikum.rejected, rejectedHandler);
  },
});

export const { reset } = TimelineSlice.actions;
export default TimelineSlice.reducer;
